import { render, staticRenderFns } from "./breadCrumb.vue?vue&type=template&id=223d49aa&scoped=true&"
import script from "./breadCrumb.vue?vue&type=script&lang=js&"
export * from "./breadCrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223d49aa",
  null
  
)

export default component.exports